/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class FileService extends __BaseService {
  static readonly FileGetFilePath = '/api/File';
  static readonly FileUploadPath = '/api/File/Upload';
  static readonly FileGetPath = '/api/File/Get/{uri}';
  static readonly FileLinkPath = '/api/File/Link/{uri}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param fileId undefined
   */
  FileGetFileResponse(fileId?: null | string): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (fileId != null) __params = __params.set('fileId', fileId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/File`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param fileId undefined
   */
  FileGetFile(fileId?: null | string): __Observable<string> {
    return this.FileGetFileResponse(fileId).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param params The `FileService.FileUploadParams` containing the following parameters:
   *
   * - `shareType`:
   *
   * - `itemId`:
   *
   * - `fileIdentifier`:
   *
   * - `file`:
   *
   * - `customerId`:
   */
  FileUploadResponse(params: FileService.FileUploadParams): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.shareType != null) __params = __params.set('shareType', params.shareType.toString());
    if (params.itemId != null) __params = __params.set('itemId', params.itemId.toString());
    if (params.fileIdentifier != null) __params = __params.set('fileIdentifier', params.fileIdentifier.toString());
    if (params.file != null) { __formData.append('file', params.file as unknown as string | Blob);}
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/File/Upload`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param params The `FileService.FileUploadParams` containing the following parameters:
   *
   * - `shareType`:
   *
   * - `itemId`:
   *
   * - `fileIdentifier`:
   *
   * - `file`:
   *
   * - `customerId`:
   */
  FileUpload(params: FileService.FileUploadParams): __Observable<string> {
    return this.FileUploadResponse(params).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param uri undefined
   */
  FileGetResponse(uri: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/File/Get/${encodeURIComponent(String(uri))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param uri undefined
   */
  FileGet(uri: string): __Observable<Blob> {
    return this.FileGetResponse(uri).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param uri undefined
   */
  FileLinkResponse(uri: string): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/File/Link/${encodeURIComponent(String(uri))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param uri undefined
   */
  FileLink(uri: string): __Observable<string> {
    return this.FileLinkResponse(uri).pipe(
      __map(_r => _r.body as string)
    );
  }
}

module FileService {

  /**
   * Parameters for FileUpload
   */
  export interface FileUploadParams {
    shareType?: null | string;
    itemId?: null | string;
    fileIdentifier?: null | string;
    file?: null | string;
    customerId?: number;
  }
}

export { FileService }
